<template>
  <div class="boss-message-box pega-primary-very-light-color-important">
    <img
      src="@/assets/images/avatar-company.svg"
      class="boss-message-box-avatar"
    >
    <div class="boss-message-header-layout">
      <div class="boss-layout-block">
        <div class="boss-message-scouted pega-primary-color-important">
          <img
            src="@/assets/images/icon-scout.svg"
            width="16"
            alt=""
          > スカウト済み
        </div>
      </div>
      <div
        class="boss-layout-block boss-message-when"
        data-test="date"
      >
        {{ date | formatDateTime }}
      </div>
    </div>
    <div
      class="boss-layout-block boss-message-recruit-title pega-primary-color-important"
      data-test="job"
    >
      求人ID：{{ job.id }}
      <br>{{ job.name }}
    </div>
    <div class="boss-layout-block">
      <div
        class="boss-message-mail-subject"
        data-test="subject"
      >
        {{ subject | formatSubject }}
      </div>
      <div
        class="boss-message-mail-body pega-pre-wrap"
        data-test="body"
        v-html="$sanitize(renderBody)"
      />
    </div>
    <div class="boss-layout-block">
      <div class="boss-bonus-check-group">
        <span
          v-for="(specialFavor, i) in specialFavors"
          :key="i"
          v-tooltip="{ content: specialFavorBy(specialFavor.id).description}"
          :data-test="'special-favor-' + i"
          class="boss-bonus-check-text pega-bonus-check-important"
        >{{ specialFavor.name }}</span>
        <span data-test="expiration-date">（有効期限：{{ expirationDate | formatDate }}まで）</span>
      </div>
    </div>
  </div>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import { mapActions, mapGetters } from 'vuex'
import util from '@/lib/util'

export default {
  filters: {
    formatDateTime (val) {
      return createDate(val)?.format('YYYY/MM/DD(ddd) HH:mm') ?? ''
    },
    formatDate (val) {
      return createDate(val)?.format('YYYY/MM/DD') ?? ''
    },
    formatSubject (val) {
      return val ? `件名：${val}` : ''
    }
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    job: {
      type: Object,
      default: () => ({
        id: null,
        name: ''
      })
    },
    subject: {
      type: String,
      default: ''
    },
    expirationDate: {
      type: String,
      default: ''
    },
    specialFavors: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    }
  },
  created () {
    this.storeMaster('specialFavors')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
